export default "__VITE_ASSET__a8deb08f__"